module.exports = __webpack_public_path__ + "static/media/postcodeBgImage-3x.a9c3c6a0.png";